// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--3fv2x","container":"index-module--container--27YCJ","image":"index-module--image--10-6x","inlineText":"index-module--inlineText--2gjqB"};